import mode from './Mode'

export default {
  developmentMode: mode === 'dev'
}



// WEBPACK FOOTER //
// ./src/settings/Settings.js